import { render } from "./WritingTool.vue?vue&type=template&id=5a0c5820&scoped=true"
import script from "./WritingTool.vue?vue&type=script&lang=js"
export * from "./WritingTool.vue?vue&type=script&lang=js"

import "./WritingTool.vue?vue&type=style&index=0&id=5a0c5820&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a0c5820"]])

export default __exports__